const urlList =[
    {'school_code':'a001','url':'https://shanghai.gaokaowin.com'},
    {'school_code':'a00e','url':'https://shanghai.gaokaowin.com'},
    {'school_code':'a016','url':'https://shanghai.gaokaowin.com'},
    {'school_code':'a016','url':'https://shanghai.gaokaowin.com'},
    {'school_code':'a01a','url':'https://funing.gaokaowin.com:8081'},
    {'school_code':'a01b','url':'https://guangnan.gaokaowin.com:8081'},
    {'school_code':'a01c','url':'https://maguan.gaokaowin.com:8082'},
    {'school_code':'a01d','url':'https://lancang.gaokaowin.com:8081'},
    {'school_code':'a01e','url':'https://zhaotong.gaokaowin.com:8081'},
    {'school_code':'a020','url':'https://yanjin.gaokaowin.com:8081'},
    {'school_code':'a021','url':'https://lijiang.gaokaowin.com:8081'},
    {'school_code':'a022','url':'https://shanghai.gaokaowin.com'},
    {'school_code':'a024','url':'https://shanghai.gaokaowin.com'},
    {'school_code':'a025','url':'https://shanghai.gaokaowin.com'},
    {'school_code':'a026','url':'https://shanghai.gaokaowin.com'},
    {'school_code':'a027','url':'https://fengzikai.gaokaowin.com:8081'},
    {'school_code':'a028','url':'https://shanghai.gaokaowin.com'},
    {'school_code':'a02a','url':'https://zhongshan.gaokaowin.com:8081'},
    {'school_code':'a02b','url':'https://shanghai.gaokaowin.com'},
    {'school_code':'a02c','url':'https://ceshi.gaokaowin.com'},
    {'school_code':'a02d','url':'https://shanghai.gaokaowin.com'},
    {'school_code':'a030','url':'https://shanghai.gaokaowin.com'},
    {'school_code':'a02f','url':'https://shanghai.gaokaowin.com'},
    {'school_code':'a032','url':'https://fuling.gaokaowin.com:8081'},
]
export default urlList;